import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import WarningBanner from '../../../../components/WarningBanner';
import { COPERTURA_NON_NOTA } from './contattiNotificheUtils';

const useStyles = makeStyles((theme) => ({
  // «Not known» is a third state and does not dress up as an alarm: there is
  // nothing to go and fix, there is a read that did not succeed.
  incerto: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    textAlign: 'left',
  },
}));

/**
 * The escalation of a deviation nobody took charge of within the hour goes to the
 * contatti di struttura (US 14). With that list empty it starts and reaches
 * nobody, and nothing else on the screen says so — an empty table reads as «not
 * configured yet», not as «the alarm is lost».
 *
 * The signal is `copertoDaContattiDiStruttura` as the server sent it, never the
 * length of the struttura list: the two can disagree the moment a second
 * technician writes, and only one of them is the server's own answer.
 */
const AvvisoEscalationSenzaDestinatari = ({ copertura }) => {
  const classes = useStyles();

  if (copertura === COPERTURA_NON_NOTA) {
    return (
      <Typography
        variant="body2"
        component="p"
        className={classes.incerto}
        data-testid="avviso-escalation-copertura-incerta"
      >
        Non è stato possibile sapere se l’escalation di questo esercizio ha dei
        destinatari: ricarica la scheda per rileggerla.
      </Typography>
    );
  }

  if (copertura !== false) {
    return null;
  }

  return (
    <WarningBanner testId="avviso-escalation-scoperta">
      Questo esercizio non ha nessun contatto di struttura: una deviazione non
      presa in carico entro un’ora escala, e l’escalation non arriverebbe a
      nessuno. Aggiungi almeno un recapito allo scope struttura.
    </WarningBanner>
  );
};

AvvisoEscalationSenzaDestinatari.propTypes = {
  // `true`, `false`, or COPERTURA_NON_NOTA — three states, kept distinct.
  copertura: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default AvvisoEscalationSenzaDestinatari;
